import Home from "./home";
import Series from "./series";
import BenefitsSection from "./benefits";
import Sports from "./sports";
import Pricing from "./pricing";
import How from "./how";
import Device from "./device";
import Reviews from "./reviws";
import Faq from "./faq";

export default function All() {
    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: "#111",
                color: "#fff"
            }}
        >
            {/* ...existing code... */}
            <Home />
            <Series />
            <BenefitsSection />
            <Sports />
            <Pricing />
            <Reviews />
            <How />
            <Device />
            <Faq />
        </div>
    );
}